// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LlIcon from "./LlIcon.bs.js";

function PlLegendLevel(Props) {
  var classNameOpt = Props.className;
  var companionId = Props.companionId;
  var level = Props.level;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: "relative pr-1 flex-shrink-0 " + className
            }, React.createElement("div", {
                  className: "w-[30px] h-[30px] sm:w-[34px] sm:h-[34px]"
                }, React.createElement(LlIcon.make, {
                      companionId: companionId,
                      size: 34
                    })), React.createElement("svg", {
                  className: "absolute bottom-[-2px] right-[-2px]",
                  height: "22",
                  width: "22"
                }, React.createElement("circle", {
                      cx: "11",
                      cy: "11",
                      fill: "rgba(33, 33, 33, 0.45)",
                      r: "10.5",
                      stroke: "var(--white1)",
                      strokeWidth: "1.5px"
                    }), React.createElement("text", {
                      fill: "var(--white1)",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: "600",
                      textAnchor: "middle",
                      x: "11",
                      y: "17"
                    }, String(level))));
}

var make = PlLegendLevel;

export {
  make ,
  
}
/* react Not a pure module */
